export default __webpack_public_path__ + "dc6ef0d4db8983f1ee67850188c2f4b9.svg";